import { Component, OnInit } from '@angular/core';
import { PermisoService } from '../../../services/permiso.service';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Router } from '@angular/router';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    providers: [PermisoService,SessionService]
})
export class MenuComponent implements OnInit {
    public loading: boolean;
    public menuItems: any[];
    public msgSweet: SweetMessage;

	constructor(
        public permisoService: PermisoService,
        private storage: AsyncLocalStorage,
        private NavRoute: Router,
        private ss: SessionService,
    ) {
        this.loading = false;
        this.msgSweet = new SweetMessage();
    }

	ngOnInit(){
        this.getDataMenu();
    }

    getDataMenu(){
        this.loading = true;
		this.permisoService.getAll("?usuario="+sessionStorage.getItem('usuario_id')+"&perfil="+sessionStorage.getItem("perfil_id")).subscribe(
			res => {
				this.menuItems = res;
				this.loading = false;
			},
			err => {
				this.loading = false;
			}
		);
    }

    openLink(link){
        this.NavRoute.navigate([link]);
    }

    openSubmenu(menu){
        this.storage.setItem("menu", menu).subscribe(() => {
			this.NavRoute.navigate(['/submenu']);
		});
    }

    logout(){
        this.msgSweet.showMessage('delete-confirm-message', "¿Desea cerrar su sesión actual?").then(
			res => {
                this.ss.deleteData().then(() => this.NavRoute.navigate(['login']));
            }
		);
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/desktop/menu/menu.component.ts